import { Routes, Route } from "react-router-dom";
import { MainLayout } from "@/components/layout/MainLayout";
import { ProtectedRoute } from "@/auth/ProtectedRoute";
import Dashboard from "@/pages/Dashboard";
import VirtualMachines from "@/pages/VirtualMachines";
import Containers from "@/pages/Containers";
import VMDetailPage from "@/pages/VMDetailPage";
import TrashedVMs from "@/pages/TrashedVMs";
import Provisioning from "@/pages/Provisioning";
import Backups from "@/pages/Backups";
import Billing from "@/pages/Billing";
import Monitoring from "@/pages/Monitoring";
import IPAM from "@/pages/IPAM";
import Knowledge from "@/pages/Knowledge";
import Onboarding from "@/pages/Onboarding";
import Topology from "@/pages/Topology";
import LoadBalancer from "@/pages/LoadBalancer";
import Ops from "@/pages/Ops";
import MonitoringDashboardsAdmin from "@/pages/admin/MonitoringDashboards";
import AdminUsers from "@/pages/admin/Users";
import AdminTenants from "@/pages/admin/Tenants";
import AdminAudit from "@/pages/admin/Audit";
import AdminVault from "@/pages/admin/Vault";
import Reconciliation from "@/pages/admin/Reconciliation";
import Settings from "@/pages/Settings";
import ConsolePage from "@/pages/ConsolePage";
import NotFound from "@/pages/NotFound";

export default function App() {
  return (
    <Routes>
      <Route path="/console" element={<ConsolePage />} />
      <Route
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/vms" element={<VirtualMachines />} />
        <Route path="/vms/trash" element={<TrashedVMs />} />
        <Route path="/vms/:id" element={<VMDetailPage />} />
        <Route path="/docker" element={<Containers />} />
        <Route path="/provisioning" element={<Provisioning />} />
        <Route path="/backups" element={<Backups />} />
        <Route path="/monitoring" element={<Monitoring />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/ipam" element={<IPAM />} />
        <Route path="/knowledge" element={<Knowledge />} />
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/topology" element={<Topology />} />
        <Route path="/lb" element={<LoadBalancer />} />
        <Route path="/ops" element={<Ops />} />
        <Route
          path="/admin/monitoring/dashboards"
          element={<MonitoringDashboardsAdmin />}
        />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/tenants" element={<AdminTenants />} />
        <Route path="/admin/audit" element={<AdminAudit />} />
        <Route path="/admin/vault" element={<AdminVault />} />
        <Route path="/admin/reconciliation" element={<Reconciliation />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
